// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__wjww8","homeBtn":"home_homeBtn__2qCgU","homeContent":"home_homeContent__1BNVS","offset":"home_offset__MOVjC"};